<template>
  <div class="lead-detail" v-if="readyToRender">
    <modal v-if="show_modal" @close-modal="toggle_modal(false)" :lead_id="modal_props.lead_id" :lead_interaction_id="modal_props.lead_interaction_id" :interaction="modal_props.data">
    </modal>
    <contact-modal v-if="show_contact_modal" @close-modal="toggle_contact_modal(false)" :lead_id="modal_contact_props.lead_id" :contact_id="modal_contact_props.contact_id" :contact="modal_contact_props.data">
    </contact-modal>
    <distribution-method-modal v-if="show_distribution_method_modal" @close-modal="toggle_distribution_method_modal(false)" :lead_id="modal_distribution_method_props.lead_id" :distribution_method_id="modal_distribution_method_props.distribution_method_id">
    </distribution-method-modal>
    <offer-modal v-if="show_offer_modal" @close-modal="toggle_offer_modal(false)" :lead_id="modal_offer_props.lead_id" :offer_id="modal_offer_props.offer_id">
    </offer-modal>
    <customer-modal v-if="show_customer_modal" @close-modal="toggle_customer_modal(false)" :lead_id="modal_customer_props.lead_id" :customer_id="modal_customer_props.customer_id">
    </customer-modal>
    <lead-modal v-if="show_lead_modal" @close-modal="toggle_lead_modal(false)" :lead_id="modal_lead_props.lead_id" :status="modal_lead_props.status" :closing_reason="modal_lead_props.closing_reason" :closing_message="modal_lead_props.closing_message" :duplicate_id="modal_lead_props.duplicate_id">
    </lead-modal>
    <delete-modal v-if="show_delete_modal" @close-modal="toggle_delete_modal(false)" :lead_id="$route.params.id">
    </delete-modal>
    <lead-head @show-modal-lead="toggle_lead_modal($event)" @reload-lead="init">
    </lead-head>
    <notifications v-if="is_any_errors"
                    :errors="errors"
                    @close-error="reset_error($event)"
                    >
    </notifications>

    <div class="lead-body-container row">
      <div class="col-lg-5 col-xs-12 lead-side-container pull-right">
        <lead-agency :current_lead="current_lead">
        </lead-agency>

        <hr>

        <div>
          <h5>DÉJÀ CLIENT / PROSPECT :</h5>

          <div v-if="!current_lead.customer_id">
            <div class="customer-attach">
              <p v-if="!customer_addition_state">Aucun client associé.</p>
              <div v-if="!closedLead">
                <button class="btn btn-success" @click="customer_addition_state = true" v-if="!customer_addition_state">Associer</button>
                <button class="btn pull-right" @click="cancel_attach_customer" v-else>Annuler</button>
              </div>
            </div>
            <div v-if="customer_addition_state">
              <div class="form-group">
                <label>Recherchez un client à lier avec ce lead</label>
                <search-and-select :initial-value="null"
                  :search-config="existingLeadCustomerSearchConfig"
                  :get-option-label="getCustomerNameWithRepresentativeAndErpId"
                  @field-updated="updateData($event, 'customer')">
                </search-and-select>
              </div>
              <div style="background-color: #fafafa; padding: 15px;" v-if="selected_customer != -1">
                <p v-if="currently_selected_customer">
                  Veuillez confirmer la séléction du client:<br><br>
                  <span v-if="currently_selected_customer.name">{{currently_selected_customer.name}}</span><br>
                  <div v-if="currently_selected_customer.main_address">
                    Adresse :
                    <span> {{ currently_selected_customer.main_address.street_line1}} </span>
                    <span> {{ currently_selected_customer.main_address.street_line2}} </span>
                    <span> {{ currently_selected_customer.main_address.zipcode}} </span>
                    <span> {{ currently_selected_customer.main_address.city}} </span>
                    <span v-if="currently_selected_customer.main_address.decoded_state"> {{ currently_selected_customer.main_address.decoded_state}} </span>
                    <span v-if="currently_selected_customer.main_address.decoded_country"> {{ currently_selected_customer.main_address.decoded_country}} </span>
                  </div>
                  <div v-if="currently_selected_customer.main_representative">
                    <p>
                        <strong>Représentant principal:</strong>
                        <span v-if="currently_selected_customer.main_representative.representative_quality">
                          {{currently_selected_customer.main_representative.decoded_representative_quality}}
                        </span>
                        <span v-if="currently_selected_customer.main_representative.civility">
                          {{currently_selected_customer.main_representative.decoded_civility}}
                        </span>
                        <span v-if="currently_selected_customer.main_representative.first_name">
                          {{currently_selected_customer.main_representative.first_name}}
                        </span>
                        <span v-if="currently_selected_customer.main_representative.last_name">
                          {{currently_selected_customer.main_representative.last_name}}
                        </span>
                        <br>
                        <strong>Contact:</strong>
                        <ul>
                          <li v-if="currently_selected_customer.main_representative.email">Email : {{currently_selected_customer.main_representative.email}}</li>
                          <li v-if="currently_selected_customer.main_representative.mobile_phone">Tél. Mobile: {{currently_selected_customer.main_representative.mobile_phone}}</li>
                          <li v-if="currently_selected_customer.main_representative.phone">Tél. : {{currently_selected_customer.main_representative.phone}}</li>
                        </ul>
                    </p>
                  </div>
                </p>
                <button  class="btn btn-success" style="display: flex;margin: auto;" @click="binding(true)">Associer</button>
              </div>
            </div>
          </div>

          <div class="row" v-else>
            <div class="col-md-6">
              <div><b>Client/Prospect associé :</b> {{ current_lead.customer.name }}</div>
              <div v-if="current_lead.customer.main_representative">
                <h5>Représentant légal :</h5>
                <div><b>Nom :</b> {{ current_lead.customer.main_representative.last_name || 'Non renseigné' }}</div>
                <div><b>Prénom :</b> {{ current_lead.customer.main_representative.first_name || 'Non renseigné' }}</div>
                <div><b>Qualité :</b> {{ current_lead.customer.main_representative.decoded_representative_quality || 'Non renseigné' }}</div>
                <div><b>Tél. fixe :</b> {{ current_lead.customer.main_representative.phone || 'Non renseigné' }}</div>
                <div><b>Tél. mobile:</b> {{ current_lead.customer.main_representative.mobile_phone || 'Non renseigné' }}</div>
              </div>
            </div>
            <div class="col-md-6" style="display: flex;justify-content: flex-end;">
                <button class="btn" @click="toggle_customer_modal({lead_id:current_lead.id, customer_id:current_lead.customer_id})" v-if="current_lead.customer_id" style="margin-right:10px;">Désassocier</button>
                <router-link v-if="current_lead.customer_id" :to="{ name: 'customer', params: { id: current_lead.customer_id } }">
                  <button class="btn btn-success">Voir client</button>
                </router-link>
            </div>
          </div>
        </div>

        <hr>

        <div>
          <div class="offer-head">
            <h5>INTERESSÉ PAR :</h5>

            <div class="buttons-container" v-if="!closedLead && !offer_addition_state">
              <button class="btn btn-success" v-if="availableDistributionMethods.length > 0" @click="addingDistributionMethod = true">Un type d'offre</button>
              <button class="btn btn-success" @click="addingOffer = true">Une offre particulière</button>
            </div>

            <div class="buttons-container" v-else-if="!closedLead">
              <button class="btn" v-if="addingOffer" @click="cancel_attach_offer">Annuler</button>
              <button class="btn" v-if="addingDistributionMethod" @click="cancelAttachDistributionMethod">Annuler</button>
            </div>
          </div>

          <div class="add-offer-form" v-if="addingOffer">
            <div class="row">
              <div class="form-group col-md-6">
                <label>Selectionner une agence</label>
                <custom-select :field="offer_fields[0]" :value="offer_fields[0]" :field_idx="0" @field-updated="selected_agency = $event.new_value ? $event.new_value.value : -1">
                </custom-select>
              </div>

              <div class="form-group col-md-6">
                <label>Selectionner un type d'offre</label>
                <custom-select :field="offer_fields[1]" :value="offer_fields[1]" :field_idx="1" @field-updated="selected_distribution_method = $event.new_value ? $event.new_value.value : -1">
                </custom-select>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-md-12" v-if="available_offers.length > 0">
                <label>Selectionner une offre parmi les choix suivants</label>

                <ul>
                  <li v-for="(available_offer, ao_idx) in available_offers">
                    <input type="radio" v-model="selected_offer" :id="available_offer.id" :value="available_offer.id">
                    <label style="margin-left: 5px;" :for="available_offer.id">{{available_offer.text}}</label>
                  </li>
                </ul>
              </div>

              <div class="col-md-12" style="text-align: right;">
                <button v-if="selected_offer != -1" class="btn btn-success"  @click="binding_offer(true)">Associer</button>
              </div>
            </div>
          </div>

          <div class="add-distribution-method-form" v-else-if="addingDistributionMethod">
            <div class="row">
              <div class="form-group col-md-8">
                <label>Selectionner un type d'offre</label>
                <custom-select :field="distribution_methods_field" :value="distribution_methods_field" :field_idx="1" @field-updated="distributionMethodToAttach = $event.new_value ? $event.new_value.value : -1">
                </custom-select>
              </div>
              <div class="col-md-4" style="text-align: right;">
                <button v-if="distributionMethodToAttach != -1" class="btn btn-success search_button"  @click="attachDistributionMethod()">Associer</button>
              </div>
            </div>
          </div>

          <lead-offers v-else
                       :lead_offers="current_lead.lead_offers"
                       :lead_distribution_methods="current_lead.lead_distribution_methods"
                       @detach-distribution-method="toggle_distribution_method_modal($event)"
                       @detach-offer="toggle_offer_modal($event)"></lead-offers>

          <div class="row">
            <div class="form-group col-md-12">
              <label>Informations complémentaires</label>
              <custom-text-area :field="offer_fields[2]" :value="offer_fields[2].value" :field_idx="2" @field-updated="offer_supplement = $event.new_value">
              </custom-text-area>
              <div v-if="!closedLead" style="display: flex;">
                <button class="btn btn-success" style="margin-left:auto;" @click="handle_offer_supplement_edition">Modifier</button>
              </div>
            </div>
          </div>
        </div>

        <hr>

        <!-- <div> Keep until it's required to delete
          <div class="contacts-head">
            <h5>CONTACTS</h5>
            <button v-if="!edition_state" style="margin-left: auto;height: 37px;" class="btn btn-success" @click="handle_contact_addition">Ajouter</button>
          </div>
          <div v-if="!edition_state">
            <contacts @remove-contact="toggle_contact_modal($event)" :lead_id="lead_id">
            </contacts>
          </div>
          <lead-item-addition v-if="edition_state" :form="creation_form_of()" @cancel="remove_form()" class="lead-contact-addition">
          </lead-item-addition>
        </div> -->
      </div>

      <div class="col-lg-7 col-xs-12 lead-interactions-container">
        <div style="display: flex; align-items: center;">
          <h5>ACTIONS</h5>
            <button class="btn btn-success"
                    style="margin-left: auto; height: 37px;"
                    @click="interactions_addition_state = true"
                    v-if="!closedLead && interactions_addition_state == false">
              Créer
            </button>
        </div>
        <div class="" v-if="!interactions_addition_state">
          <lead-interactions
            @remove-interaction="toggle_modal($event)"
            @scheduled-interaction-realized="interactions_addition_state = true"
          >
          </lead-interactions>
        </div>
        <div v-if="interactions_addition_state" style="padding: 20px;border:solid 1px ligthgrey;background-color:#F8F8F8;margin-top: 10px;">
          <br>
          <div class="form-group" >
            <label style="margin-right: 5px;">Sélectionner un type</label>
            <custom-select :field="interactions_fields[0]" :value="interactions_fields[0].value" :field_idx="0" @field-updated="selected_type = $event.new_value ? $event.new_value.value : null">
            </custom-select>
          </div>
          <div class="" v-if="selected_type == 'other'">
            <label>Nom de l'interaction</label>
            <custom-text :field="interactions_fields[1]" :value="interactions_fields[1].value" :field_idx="1" @field-updated="interaction_other_name = $event.new_value">
            </custom-text>
          </div>
          <div class="" v-if="selected_type == 'document_sending'">
            <!-- <div>
              <label>Sélectionner un mail type</label>
              <custom-select :field="interactions_fields[7]" :value="interactions_fields[7].value" :field_idx="7" @field-updated="selected_sending_document_type = $event.new_value ? $event.new_value.value : null">
              </custom-select>
            </div>-->
            <div class="form-group">
              <label>Email du destinataire
              </label>
              <custom-text :field="interactions_fields[2]" :value="interactions_fields[2].value" :field_idx="2" @field-updated="interaction_send_email = $event.new_value">
              </custom-text>
            </div>
            <!-- <div>
              <label>Votre nom et prénom (qui apparaîtront en signature du mail)</label>
              <custom-text :field="interactions_fields[8]" :value="interactions_fields[8].value" :field_idx="8" @field-updated="sending_document_signature = $event.new_value">
              </custom-text>
            </div>

            <div v-if="default_agency != null">
              <label>Agences</label>
              <custom-select :field="interactions_fields[3]" :value="default_agency" :field_idx="3" @field-updated="updateData($event, 'agencies')">
              </custom-select>
            </div>
            <br>
            <div v-if="medias.length">
              Médias disponibles pour les agences selectionnées:
              <ul>
                <li v-for="(media, media_idx) in medias" :key="'media_' + media_idx">
                  <input type="checkbox" :id="media.id" :value="media.id" v-model="selected_medias" @change="update_checkstate_of_medias_and_refresh(media.id)" :key="'media-' + media_idx">
                  </input>
                  <label :for="media.id"><a target="_blank" :href="base_path + '/photos/' + media.id + '/' + media.file_name"> {{get_agency_name(media.agency_id)}} / {{media.file_name}}</a></label>
                </li>
              </ul>
            </div>
            <div v-else>
              <strong>Aucun documents n'est disponible dans cette agence</strong>
              <br>
              <br>
            </div> -->
          </div>
          <div class="form-group">
            <label>Commentaire pour votre suivi</label>
            <custom-text-area :field="interactions_fields[4]" :value="interactions_fields[4].value" :field_idx="4" @field-updated="interaction_message = $event.new_value">
            </custom-text-area>
          </div>

          <div class="" style="display: flex;align-items: center;" v-if="selected_type != 'document_sending'">
            <custom-checkbox :field="interactions_fields[5]" :value="interactions_fields[5].value" :field_idx="5" @field-updated="interaction_planified = $event.new_value">
            </custom-checkbox>
            <custom-date-picker v-if="interaction_planified" :start_date="now" :field="interactions_fields[6]" :value="interactions_fields[6].value" :field_idx="6" @field-updated="recall_date = $event.new_value">
            </custom-date-picker>

          </div>
          <div class="" style="display:flex;" >
            <button style="margin-left: auto;margin-right: 5px;" class="btn" @click.prevent="cancel_interaction_creation">Annuler</button>
            <button class="btn btn-success" @click="try_post_interaction">Valider</button>
          </div>
        </div>
      </div>
    </div>

    <div class="lead-footer-container row" v-if="!closedLead && check_access">
      <div class="buttons-container col-xs-12">
        <button class="btn btn-success pull-right" @click="toggle_delete_modal(true)">Supprimer le lead</button>
      </div>
    </div>
  </div>
</template>

<script>
import Contacts from "components/CRM/Contacts"
import LeadItemAddition from "components/CRM/LeadItemAddition"
import Select2 from "components/Form/Select2"
import Notifications from "components/CRM/Notifications"
import LeadInteractions from "components/CRM/Interactions/List"
import LeadOffers from "components/CRM/LeadOffers"
import CreationFormForInteraction from "components/CRM/Interactions/Form"
import Modal from "components/CRM/Interactions/InteractionModal"
import ContactModal from "components/CRM/ContactModal"
import DistributionMethodModal from "components/CRM/DistributionMethods/DistributionMethodModal"
import OfferModal from "components/CRM/Offers/OfferModal"
import CustomerModal from "components/CRM/Customer/Modal"
import LeadModal from "components/CRM/LeadModal"
import DeleteModal from "components/CRM/DeleteModal"
import LeadAgency from "components/CRM/LeadAgency"
import CustomSelect from "components/Forms/Elements/Select"
import SearchAndSelect from "components/Forms/Elements/SearchAndSelect"
import CustomText from "components/Forms/Elements/Text"
import CustomCheckbox from "components/Forms/Elements/Checkbox"
import CustomDatePicker from "components/Forms/Elements/Datepicker"
import CustomTextArea from "components/Forms/Elements/TextArea"
import LeadHead from "components/CRM/LeadHead"

import customerMixin from 'mixins/customer'
import searchMixin from 'mixins/search'

import {mapGetters, mapActions, mapState} from "vuex"

export default {
  name:"Lead",

  components:{
    Contacts,
    LeadItemAddition,
    Select2,
    Notifications,
    LeadOffers,
    LeadInteractions,
    CreationFormForInteraction,
    Modal,
    ContactModal,
    DistributionMethodModal,
    OfferModal,
    CustomerModal,
    LeadModal,
    DeleteModal,
    LeadAgency,
    CustomSelect,
    SearchAndSelect,
    CustomText,
    CustomTextArea,
    CustomCheckbox,
    CustomDatePicker,
    LeadHead
  },

  mixins: [customerMixin, searchMixin],

  data() {
    return {
      base_path:__API_URL__,
      show_modal:false,
      show_contact_modal:false,
      show_distribution_method_modal:false,
      show_offer_modal:false,
      show_customer_modal:false,
      show_lead_modal:false,
      show_delete_modal:false,
      modal_props:{},
      modal_contact_props:{},
      modal_distribution_method_props:{},
      modal_offer_props:{},
      modal_customer_props:{},
      modal_lead_props:{},
      lead_id:this.$route.params.id,
      edition_state:false,
      customer_addition_state:false,
      addingOffer:false,
      addingDistributionMethod:false,
      search_customer:"",
      selected_customer:-1,
      debounced_search_customer:null,
      selected_agency:-1,
      selected_offer:-1,
      selected_distribution_method:-1,
      distributionMethodToAttach:-1,
      interactions_addition_state:false,
      planified_interaction_addition_state:false,
      selected_state:null,
      available_states:[
        {id:"open", text:"Ouvert"},
        {id:"completed", text:"Contrat complété"},
        {id:"in_progress", text:"En cours"},
        {id:"converted", text:"Converti"},
        {id:"duplicate", text:"Doublon"},
        {id:"closed", text:"Abandonné"},
      ],
      closing_reason:null,
      available_options_types:[
        {
          id:"phone_call",
          text:"Appel téléphonique"
        },
        {
          id:"email",
          text:"E-mail"
        },
        {
          id:"document_sending",
          text:"Envoi de documents / Offre domiciliation"
        },
        {
          id:"other",
          text:"Autre"
        },
      ],
      selected_type:null,
      recall_date:null,
      selected_agencies:[],
      selected_medias:[],
      interaction_planified:true,
      interaction_message:"",
      interaction_send_email:"",
      interaction_other_name:"",
      selected_origin_supplement:-1,
      linked_agency:"-1",
      agency_initialize:false,
      currently_selected_customer:null,
      default_agency:null,
      available_doctypes:[
        {id:"domiciliation_offer", text:'Offre commerciale domiciliation'},
        {id:'office_offer', text:'Offre bureaux longue durée'},
        {id:'punctual_booking_offer', text:'Offre bureaux courte durée'}
      ],
      selected_sending_document_type:null,
      sending_document_signature:"",
      offer_supplement:"",
    }
  },

  methods :{
    ...mapActions("crm", [
      "fetch_a_lead",
      "set_fetching_state",
      "fetch_all_contacts",
      "fetch_contact_creation_form",
      "reset_form",
      "attach_lead",
      "unattach_lead",
      "fetch_customers",
      "reset_customers",
      "reset_errors",
      "reset_error",
      "fetch_distributions_methods",
      "reset_offers",
      "fetch_offers",
      "attach_offer_to_lead",
      "detach_offer_of_lead",
      "attachDistributionMethodTolead",
      "fetch_agencies",
      "fetch_medias",
      "reset_medias",
      "update_checkstate_of_medias",
      "create_interaction",
      "fetch_interactions",
      "create_scheduled_interaction",
      "fetch_all_leads",
      "set_medias",
      "clear_current_lead",
      "update_lead_agency",
      "reset_form_errors",
      "update_offer_supplement"
    ]),

    updateData(event, flag)
    {
      if (flag === 'customer')
      {
        this.selected_customer = event ? event.id : -1
        this.currently_selected_customer = event
      }
      else if (flag === 'agencies') {
        this.selected_agencies = event.new_value
        this.set_fetching_state(true)
        let p0 = new Promise((resolve, reject) => {this.reset_medias()})
        let p1 = new Promise((resolve, reject) => {
              _.each(this.selected_agencies, agency => {
                this.fetch_medias(agency.value)
              })
          })
        let p2 = new Promise((resolve, reject) => {
          this.set_fetching_state(false)
        })
        p0.then(p1).then(p2)
      }
    },

    try_up_agency() {
      this.update_lead_agency({lead_id:this.lead_id, params:{agency_id:this.linked_agency}})
          .then(() => this.init())
    },

    handle_contact_addition()
    {
      this.edition_state = true
      this.set_fetching_state(true)
      this.fetch_contact_creation_form(this.lead_id)
          .then(() => this.set_fetching_state(false))
    },

    creation_form_of()
    {
      var exists = _.find(this.forms, ctc => ctc.lead_id == this.lead_id && ctc.flag)
      if (exists !== undefined)
        return exists.form
      return null
    },

    remove_form()
    {
      this.reset_form(_.filter(this.forms, form => form.lead_id != this.lead_id))
      this.edition_state = false
    },

    get_customers()
    {
      this.reset_errors()
      this.reset_customers()
      this.set_fetching_state(true)
      this.fetch_customers({search:this.search_customer})
          .then(() => this.set_fetching_state(false))
    },

    get_offers()
    {
      this.reset_errors()
      this.reset_offers()
      this.set_fetching_state(true)
      var params = {}
      if (this.selected_agency != -1)
        params = _.assign(params, {agencies:[this.selected_agency]})
      if (this.selected_distribution_method != - 1)
        params = _.assign(params, {distribution_methods:[this.selected_distribution_method]})
      this.fetch_offers(params)
          .then(() => this.set_fetching_state(false))
    },

    handle_offer_supplement_edition(event)
    {
      let p = {lead_id:this.current_lead.id, body:{offer_supplement:this.offer_supplement}}
      this.update_offer_supplement(p)
          .then(() => this.init())
    },

    init() {
      this.set_fetching_state(true)
      this.fetch_distributions_methods()
      this.fetch_a_lead(this.lead_id)
          .then(() => {
            this.selected_state = this.current_lead.status
            this.closing_reason = this.current_lead.closing_reason
            this.selected_origin_supplement = this.current_lead.origin_supplement
            this.set_fetching_state(false)
          })
    },

    beforeRouteUpdate()
    {
      this.init()
    },

    reset_data() {
      this.search_customer = ""
      this.selected_customer = -1
      this.selected_offer = -1
      this.selected_agency=-1,
      this.selected_offer=-1,
      this.selected_distribution_method=-1
      this.distributionMethodToAttach=-1
      this.reset_customers()
    },

    cancel_attach_customer()
    {
      this.reset_data()
      this.customer_addition_state = false
    },

    cancel_attach_offer()
    {
      this.reset_data()
      this.reset_offers()
      this.addingOffer = false
    },

    cancelAttachDistributionMethod()
    {
      this.reset_data()
      this.addingDistributionMethod = false
    },

    cancel_interaction_creation()
    {
      this.interactions_addition_state = false
      this.planified_interaction_addition_state = false
      this.recall_date = null
      this.selected_agencies=[]
      this.selected_medias=[]
      this.selected_type = null
      this.interaction_message=""
      this.interaction_planified=true
      this.interaction_other_name=""
      this.interaction_send_email=""
      this.selected_sending_document_type = null
      this.sending_document_signature = ""
    },

    binding(flag)
    {
      if (flag)
      {
        this.set_fetching_state(true)
        this.attach_lead({lead_id:this.current_lead.id, customer_id:this.selected_customer})
            .then(() => this.init())
      }
      else {
        this.set_fetching_state(true)
        this.unattach_lead({lead_id:this.current_lead.id})
          .then(() => this.init())
      }
      this.reset_data()
    },

    binding_offer(flag)
    {
      if (flag)
      {
        this.set_fetching_state(true)
        this.attach_offer_to_lead({lead_id:this.current_lead.id, offer_id:this.selected_offer})
            .then(() => this.init())
      }
      else {
        this.set_fetching_state(true)
        this.detach_offer_of_lead({lead_id:this.current_lead.id, offer_id:this.selected_offer})
          .then(() => this.init())
      }
      this.cancel_attach_offer()
    },

    attachDistributionMethod()
    {
      this.set_fetching_state(true)
      this.attachDistributionMethodTolead({lead_id:this.current_lead.id, distribution_method_id:this.distributionMethodToAttach})
          .then(() => {
            this.cancelAttachDistributionMethod()
            this.init()
          })
    },

    toggle_modal(event) {
      if (event)
      {
        this.modal_props = event
        this.show_modal = true
      }
      else
      {
        this.modal_props = {}
        this.show_modal = false
      }
    },

    toggle_contact_modal(event) {
      if (event)
      {
        this.modal_contact_props = event
        this.show_contact_modal = true
      }
      else
      {
        this.modal_contact_props = {}
        this.show_contact_modal = false
      }
    },

    toggle_offer_modal(event) {
      if (event)
      {
        this.modal_offer_props = event
        this.show_offer_modal = true
      }
      else
      {
        this.modal_offer_props = {}
        this.show_offer_modal = false
      }
    },

    toggle_distribution_method_modal(event) {
      if (event)
      {
        this.modal_distribution_method_props = event
        this.show_distribution_method_modal = true
      }
      else
      {
        this.modal_distribution_method_props = {}
        this.show_distribution_method_modal = false
      }
    },

    toggle_customer_modal(event) {
      if (event)
      {
        this.modal_customer_props = event
        this.show_customer_modal = true
      }
      else
      {
        this.modal_customer_props = {}
        this.show_customer_modal = false
      }
    },

    toggle_lead_modal(event) {
      if (event)
      {
        this.modal_lead_props = event
        this.show_lead_modal = true
      }
      else
      {
        this.modal_lead_props = {}
        this.show_lead_modal = false
      }
    },

    toggle_delete_modal(event) {
      if (event)
      {
        this.show_delete_modal = true
      }
      else
      {
        this.show_delete_modal = false
      }
    },

    gen_title_string(){
      var txt = ""
      if (this.current_lead.contact_name)
        txt += this.current_lead.contact_name
      if (this.current_lead.contact_name && this.current_lead.contact_phone || this.current_lead.contact_name && this.current_lead.contact_email)
        txt += " - "
      if (this.current_lead.contact_phone)
        txt += this.current_lead.contact_phone
      if (this.current_lead.contact_email && this.current_lead.contact_phone)
        txt += " - "
      if (this.current_lead.contact_email)
        txt += this.current_lead.contact_email
      return txt
    },

    get_email_of(){
      return (this.current_lead.creating_user != null) ? this.current_lead.creating_user.email : null
    },

    get_agency_name(aid){
      var found = _.find(this.agencies, a => a.id == aid)
      if (found)
      {
        return found.name
      }
      return "Agence inconnue"
    },

    update_checkstate_of_medias_and_refresh(media_id)
    {
      this.update_checkstate_of_medias({media_id:media_id, sa:this.sa})
    },

    try_post_interaction()
    {
      var body = {
        interaction:{
          type:this.selected_type,
          other_type:this.interaction_other_name,
          document_sending_email:this.interaction_send_email,
          document_sending_type:this.selected_sending_document_type,
          document_sending_name:this.sending_document_signature,
          message:this.interaction_message,
          interaction_date:moment().format("YYYY-MM-DD HH:mm:ss")
        }
      }
      this.reset_errors()
      this.set_fetching_state(true)
      if (!this.interaction_planified)
        this.create_interaction({lead_id:this.current_lead.id, body:body, medias:this.selected_medias})
            .then(() => {

                this.fetch_a_lead(this.current_lead.id)
                    .then(() => {
                      this.fetch_all_leads()
                          .then(() => this.set_fetching_state(false))
                      if (!this.is_any_errors)
                        this.cancel_interaction_creation()
                      })
                  this.set_medias([])
                })
      else {
        console.log("create a planified interaction")
        if (this.recall_date != null)
          body.interaction = _.assign(body.interaction, {scheduled_date:moment(this.recall_date, "DD/MM/YYYY").format("YYYY-MM-DD HH:mm:ss")})
        this.create_scheduled_interaction({lead_id:this.current_lead.id, body:body, medias:this.selected_medias})
            .then(() => {
                this.fetch_a_lead(this.current_lead.id)
                    .then(() => {
                      this.fetch_all_leads()
                          .then(() => this.set_fetching_state(false))
                      if (!this.is_any_errors)
                        this.cancel_interaction_creation()

                    })
                this.set_medias([])
              })
      }
    },

    agencyName(agency_id)
    {
      var found = _.find(this.full_agencies, a => a.id == agency_id)
      if (found)
        return found.text
      return null
    }
  },

  computed: {
    ...mapGetters("crm", ["current_lead","forms","contacts","is_fetching","customers_as_options","is_any_errors","errors", "distribution_methods","available_offers","customers", "medias"]),
    ...mapState(["agencies", "user"]),
    ...mapState("crm", ["users"]),
    ...mapGetters("customers", ["selectAgenciesList"]),

    check_access()
    {
      var res = false
      if (this.user && this.user.me)
        _.each(this.user.me.roles, (role) => {
          if (role.name == 'green-number' || role.name == 'manager' || role.name == 'administrator' || role.name == 'super-administrator')
            res = true
        })
      return res
    },

    sa() {
      return this.selected_agencies
    },

    readyToRender() {
      if (this.current_lead && this.agency_initialize == false)
        {
          this.linked_agency = this.current_lead.agency_id != null ? String(this.current_lead.agency_id) : "-1"
          this.agency_initialize = true

        }
      return this.current_lead && this.contacts != null
    },

    readyToRenderAgencySelect(){
      if (this.linked_agency)
        return true
      return false
    },

    full_agencies()
    {
      var cpy = this.selectAgenciesList
      if (_.find(cpy, a => a.id == -1) == undefined)
          cpy.push({id:-1, text:"Aucune"})
      return cpy
    },

    offer_addition_state() {
      return this.addingOffer || this.addingDistributionMethod
    },

    offer_fields() {
      let v = [
        {values:this.full_agencies, multiple:false, placeholder:"", disabled:this.is_fetching, idx:0, required:false, value:this.selected_agency, label:"Agence",type:"select"},
        {values:this.distribution_methods, multiple:false, placeholder:"", disabled:this.is_fetching, idx:1, required:false, value:this.selected_distribution_method, label:"Agence",type:"select"},
        {values:[], multiple:false, placeholder:"", disabled:this.is_fetching, idx:2, required:false, value:this.current_lead.offer_supplement, label:"",type:"textarea"},
      ]

      return v
    },

    availableDistributionMethods() {
      // Distribution methods that are not already associated to the lead
      const distributionMethods = this.distribution_methods
      const leadDistributionMethods = this.current_lead.lead_distribution_methods

      return _.filter(distributionMethods, function(dm) {
        return _.find(leadDistributionMethods, {distribution_method_id: dm.id}) == undefined
      })
    },

    distribution_methods_field() {
      return {
        values:this.availableDistributionMethods,
        multiple:false,
        placeholder:"",
        disabled:this.is_fetching,
        idx:0,
        required:false,
        value:this.distributionMethodToAttach,
        label:"Type d'offre",
        type:"select"
      }
    },

    interactions_fields()
    {

      let v = [
        {values:this.available_options_types, multiple:false, placeholder:"Type", disabled:this.is_fetching, idx:0, required:false, value:this.selected_type, label:"",type:"select"},
        {values:[], multiple:false, placeholder:"", disabled:this.is_fetching, idx:1, required:false, value:this.interaction_other_name, label:"",type:"text"},
        {values:[], multiple:false, placeholder:"", disabled:this.is_fetching, idx:2, required:false, value:this.interaction_send_email, label:"",type:"text"},
        {values:this.agencies, multiple:true, placeholder:"", disabled:this.is_fetching, idx:3, required:false, value:this.selected_agencies, label:"Agence",type:"select"},
        {values:[], multiple:false, placeholder:"", disabled:this.is_fetching, idx:4, required:false, value:this.interaction_message, label:"",type:"textarea"},
        {values:[], multiple:false, placeholder:"", disabled:this.is_fetching, idx:5, required:false, value:this.interaction_planified, label:"Je souhaite ajouter une date de rappel",type:"checkbox"},
        {values:[], multiple:false, placeholder:"", disabled:this.is_fetching, idx:6, required:false, value:this.recall_date, label:"",type:"datepicker"},
        {values:this.available_doctypes, multiple:false, placeholder:"", disabled:this.is_fetching, idx:7, required:false, value:this.selected_sending_document_type, label:"Sélectionner un mail type",type:"select"},
        {values:[], multiple:false, placeholder:"", disabled:this.is_fetching, idx:8, required:false, value:this.sending_document_signature, label:"",type:"text"},

      ]
      return v
    },

    closedLead() {
      return 'closed' == this.current_lead.status
    },

    now() {
        return moment().format('DD/MM/YYYY')
    }
  },

  beforeDestroy(){
      this.linked_agency = null
      this.agency_initialize = false
      this.clear_current_lead()
      this.reset_form_errors()
      this.reset_errors()
  },

  created() {
    this.reset_errors()
    this.reset_form_errors()
    this.debounced_search_customer = _.debounce(this.get_customers, 3500)
    this.init()
  },

  watch :{
    selected_distribution_method : function () {
      if (this.selected_distribution_method >= 0 && this.selected_agency >= 0 && !this.is_fetching)
        this.get_offers()
    },
    selected_agency : function () {
      if (this.selected_distribution_method >= 0 && this.selected_agency >= 0 && !this.is_fetching)
        this.get_offers()
    },
    selected_type : function (newv, oldv) {
      if (newv != "none" && newv != null) {
        this.interactions_addition_state = true
      }
      if (newv != 'document_sending') {
        this.interaction_planified = true
      } else {
        this.interaction_planified = false
      }
      this.selected_medias=[]
      this.selected_agencies = []
      this.interaction_message=""
      this.interaction_other_name=""
      this.interaction_send_email=""
      if (newv == 'document_sending')
      {
        this.interaction_send_email=this.current_lead.contact_email
        let found = _.find(this.full_agencies, a => a.id == this.linked_agency)
        if (found != undefined)
          {
            this.default_agency = found.id
            this.selected_agencies = [this.default_agency]
          }
      }
    },
    current_lead(){
      if (this.current_lead)
        this.linked_agency = this.current_lead.agency_id
    },
  },
}
</script>

<style scoped lang="scss">
.lead-detail {
  .feature-block {
    margin-bottom: 20px;
  }
}

.head-container {
  padding:20px;

}

.contacts-head {
  display: flex;
}

.head-ope {
  justify-content: flex-end;
}

.head-container h4 {
  margin-left: 15px;
}

.first-row {
  height:60px;
}

.first-row div {
  height: inherit;
  display: flex;
  align-items: center;
}

.second-row {
  margin: 20px;
}

.customer-attach {
    display: flex;
}

.search-customer-button {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
}

h5 {
  color:#fb557a;
}

.customer-attach div {
    margin-left: auto;
}

.offer-head {
  display: flex;
  justify-content: space-between;

  > * {
    // width: 100%;

    &.buttons-container {
      text-align: right;

      button {
        margin-top: 5px;
      }
    }
  }
}

.add-offer-form, .add-distribution-method-form {
  padding-top: 20px;
}

.lead-infos {
    padding:20px;
    width: -webkit-fill-available;
}

.lead-body-container {
  background: white;
}

.lead-footer-container {
  background-color: #fff;

  > .buttons-container {
    margin: 20px 0;
  }
}

.lead-ope {
  margin: auto;
  margin-left: 5px;
  padding: 20px;
}

.lead-infos-block {
  padding: 20px;
  display: flex;
  width: 100%;
}

.lead-contact-ope {
  margin: auto;
  margin-top: 20px;
  max-width: 15%;
}

.lead-contact-addition {
  padding: 20px;
}

.search_button {
  margin-top:25px;
}

.lead-contact-ope-item {
  margin-bottom: 5px;
}


.closed-lead {
  height: 37px !important;
  background-color: #fc7795;
  border-color: #fc7795;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// client/views/CRM/Lead.vue